<template>
    <router-view/>
</template>

<script>
    export default {
        name: 'Movimentacao'
    }
</script>

<style scoped>

</style>
